<template>
<div class="container-create">
    <!-- <img :src="require('@/assets/menu/settings.png')" /> -->
    <div class="loginimagemdir">
        <img :src="require('@/assets/login_bonecos/dir.svg')" />
    </div>
    <div class="loginimagemesq">
        <img :src="require('@/assets/login_bonecos/esq.svg')" />
    </div>
    <div class="maincontainer-create">
        <div class="buttons-create">
            <button @click="$emit('login')" class="login-createpage"> {{$t('menu.create.login')}} </button>
            <button class="create-createpage"> {{$t('menu.create.create')}} </button>
        </div>
        <form id="create" @submit="checkForm" method="post" novalidate="true" class="form-create">
            <div class="container-createpage">
                <div class="input-create">
                    <input name="email" id="email" type="text" placeholder="Email" v-model="email" class="input-createpage" />
                    <input name="username" id="username" type="text" placeholder="Username" v-model="username" class="input-createpage" />
                    <input name="password" id="password" type="password" placeholder="Password" v-model="password" class="input-createpage" />
                    <input name="confirm_password" id="confirm_password" type="password" placeholder="Confirm your password" @input="input" v-model="confirm_password" class="input-createpage" />
                </div>
            </div>
            <button type="submit" value="Submit" class="start-createpage">
                {{$t('menu.create.button')}}
            </button>
        </form>
    </div>
    <div class="avisos-createpage">
        <span class="popupEmail-createpage popup-create">
          <img :class="{ 'hidden-create' : erroEmail == false }" :src="require('@/assets/menu/errorBox.svg')"/>
          <span class="error-createpage" v-if="erroEmail"> {{ errorEmail }} </span>
        </span>
        <span class="popupUsername-createpage popup-create">
            <img :class="{ 'hidden-create' : erroUsername == false }" :src="require('@/assets/menu/errorBox.svg')" />
            <span class="error-createpage" v-if="erroUsername"> {{ errorUser }} </span>
        </span>
        <span class="popupPass-createpage popup-create">
            <img :class="{ 'hidden-create' : erroPass == false }" :src="require('@/assets/menu/errorBox.svg')" />
            <span class="error-createpage" v-if="erroPass"> {{ errorPass }} </span>
        </span>
        <span class="popupConfirmPass-createpage popup-create">
            <img :class="{ 'hidden-create' : erroConfirmPass == false }" :src="require('@/assets/menu/errorBox.svg')" />
            <span class="error-createpage" v-if="erroConfirmPass"> {{ errorConfirmPass }} </span>
        </span>
    </div>

</div>
</template>

<script>
export default {
    name: "create",
    emits: ['enter', 'login'],
    components: {},
    data() {
        return {
            erros: [],
            erroEmail: false,
            erroUsername: false,
            erroPass: false,
            erroConfirmPass: false,
            errorEmail: '',
            errorUser: '',
            errorPass: '',
            errorConfirmPass: '',
            email: '',
            username: '',
            password: '',
            confirm_password: ''
        }
    },
    methods: {
        checkForm: function (e) {
            this.erros = [];

            if (this.email) {
                this.erroEmail = false;
            } else if (!this.email) {
                this.errorEmail = 'Email required.'
                this.erros.push('erro1')
                this.erroEmail = true;
            }

            if (!this.username) {
                this.errorUser = 'Username required.';
                this.erros.push('erro1');
                this.erroUsername = true;
            } else {
                this.erroUsername = false;
            }

            if (this.password) {
                this.erroPass = false;
            } else if (!this.password) {
                this.errorPass = 'Password required.'
                this.erros.push('erro2')
                this.erroPass = true;
            }
            if (!this.confirm_password) {
                this.errorConfirmPass = 'Password required.'
                this.erroConfirmPass = true;
            } else {
                this.erroConfirmPass = false;
            }

            if (!this.erros.length) {
                this.signin();
            }
            e.preventDefault();
            console.log(this.erros);
        },
        signin() {
            fetch(process.env.VUE_APP_API_URL + "/signin", {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "*",
                    //"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    Accept: "application/json, text/plain, */*",
                },
                method: "POST",
                body: JSON.stringify({
                    email: this.email,
                    username: this.username,
                    password: this.password
                })
            }).then((res) => {
                return res.json();
            }).then((devs) => {
                this.$emit('enter', devs);
            }).catch((error) => {
                this.$emit('not-enter', {
                    error
                });
            })
        }
    },
};
</script>

<style>
.container-create {
    pointer-events: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-family: Omnes;
    font-style: normal;
    /* background-color: white; */
}

/* .container-create > img {
  width: 100%;
  height: 100%;
  z-index: -1;
  object-fit: cover;
}
*/

.loginimagemesq {
    width: 35%;
    float: left;
    position: absolute;
    margin-left: -6%;
    margin-top: 70%;

}

.loginimagemdir {
    width: 40%;
    float: right;
    position: absolute;
    margin-left: 70%;
    margin-top: 70%;
}

.container-create>* {
    pointer-events: auto;
    flex-shrink: 0;
}

.maincontainer-create {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    transition: opacity 0.3s ease;
    top: 0;
    z-index: 100;
}

@keyframes startcreate {
    0% {
        margin-top: 5%;
    }

    100% {
        margin-top: 0;
    }
}

.form-create {
    margin-top: 2%;
    width: 42%;
    text-align: center;
}

.container-createpage {

    padding: 0.2rem;
    border-radius: 20px;
}

.buttons-create {
    width: 42%;
    margin-top: 2%;
    display: flex;
    justify-content: space-between;
}

.login-createpage {
    font-family: Omnes;
    border: none;
    padding: 3%;
    width: 45%;
    background-color: white;
    border: solid black;
    color: black;
    border-radius: 30px;
    font-style: normal;
    font-weight: bold;
    font-size: 1rem;
}

.create-createpage {
    background-color: black;
    color: white;
    border-radius: 30px;
    border: none;
    padding: 3%;
    width: 45%;
    font-style: normal;
    font-weight: bold;
    font-family: Omnes;
    font-size: 1rem;
}

.start-createpage {
    margin-top: 4%;
    background-color: black;
    color: white;
    border: none;
    border-radius: 30px;
    padding: 3%;
    width: 40%;
    font-family: Omnes;
    font-weight: bold;
    font-style: normal;
    font-size: 1rem;
}

::placeholder {
    color: black;
    font-family: Omnes;
}

.input-create {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-evenly;
}

.error-createpage {
    color: white;
    position: absolute;
    left: 83%;
    margin-top: 2%;
    width: 100%;
}

.hidden-create {
    visibility: hidden;
}

.input-createpage {
    padding: 3%;
    margin: 1.5% 1.5%;
    background-color: white;
    border: solid black;
    border-radius: 30px;
    font-family: Omnes;
    font-weight: bold;
    font-style: normal;
}

span>img {
    width: 100%;
}

.avisos-createpage {
    width: 90%;
    align-items: flex-end;
    margin-top: 3.5%;
    position: absolute;
    height: 96%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    top: 0;
}

.popup-create {
    width: 21%;
    margin-bottom: 1.5%;
    display: flex;
}

.popup-create>img {
    width: 100%;
}

@media only screen and (max-width: 480px) {
    .login-createpage {
        font-size: 0.5rem;
    }

    .create-createpage {
        font-size: 0.5rem;
    }

    .start-createpage {
        font-size: 0.5rem;
    }

    .input-createpage {
        font-size: 0.4rem;
    }

    .error-createpage {
        font-size: 0.4rem;
    }

}

@media only screen and (min-width: 480px) and (max-width: 550px) {
    .login-createpage {
        font-size: 0.6rem;
    }

    .create-createpage {
        font-size: 0.6rem;
    }

    .start-createpage {
        font-size: 0.6rem;
    }

    .input-createpage {
        font-size: 0.5rem;
    }

    .error-createpage {
        font-size: 0.5rem;
    }

}

@media only screen and (min-width: 550px) and (max-width: 630px) {
    .login-createpage {
        font-size: 0.7rem;

    }

    .create-createpage {
        font-size: 0.7rem;

    }

    .start-createpage {
        font-size: 0.7rem;
    }

    .input-createpage {
        font-size: 0.6rem;
    }

    .error-createpage {
        font-size: 0.6rem;
    }

}

@media only screen and (min-width: 630px) and (max-width: 718px) {
    .login-createpage {
        font-size: 0.8rem;
    }

    .create-createpage {
        font-size: 0.8rem;
    }

    .start-createpage {
        font-size: 0.8rem;
    }

    .input-createpage {
        font-size: 0.7rem;
    }

    .error-createpage {
        font-size: 0.7rem;
    }

}

@media only screen and (min-width: 718px) and (max-width: 806px) {
    .login-createpage {
        font-size: 0.9rem;

    }

    .create-createpage {
        font-size: 0.9rem;
    }

    .start-createpage {
        font-size: 0.9rem;
    }

    .input-createpage {
        font-size: 0.8rem;
    }

    .error-createpage {
        font-size: 0.8rem;
    }
}

@media only screen and (min-width: 806px) and (max-width: 1024px) {
    .login-createpage {
        font-size: 1rem;
    }

    .create-createpage {
        font-size: 1rem;
    }

    .start-createpage {
        font-size: 1rem;
    }

    .input-createpage {
        font-size: 0.9rem;
    }

    .error-createpage {
        font-size: 0.9rem;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {
    .login-createpage {
        font-size: 1.1rem;
        border-radius: 45px;
    }

    .create-createpage {
        font-size: 1.1rem;
        border-radius: 45px;
    }

    .start-createpage {
        font-size: 1.1rem;
        border-radius: 45px;
    }

    .input-createpage {
        font-size: 1rem;
    }

    .container-create {
        border-radius: 35px;
    }

    .error-createpage {
        font-size: 1rem;
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {
    .login-createpage {
        font-size: 1.2rem;
        border-radius: 45px;
    }

    .create-createpage {
        font-size: 1.2rem;
        border-radius: 45px;
    }

    .start-createpage {
        font-size: 1.2rem;
        border-radius: 45px;
    }

    .input-createpage {
        font-size: 1.1rem;
    }

    .container-create {
        border-radius: 35px;
    }

    .error-createpage {
        font-size: 1.1rem;
    }
}

@media only screen and (min-width: 1366px) and (max-width: 1540px) {
    .login-createpage {
        font-size: 1.3rem;
        border-radius: 45px;
    }

    .create-createpage {
        font-size: 1.3rem;
        border-radius: 45px;
    }

    .start-createpage {
        font-size: 1.3rem;
        border-radius: 45px;
    }

    .input-createpage {
        font-size: 1.2rem;
    }

    .container-create {
        border-radius: 35px;
    }

    .error-createpage {
        font-size: 1.2rem;
    }
}

@media only screen and (min-width: 1540px) and (max-width: 1680px) {
    .login-createpage {
        font-size: 1.4rem;
        border-radius: 60px;
    }

    .create-createpage {
        font-size: 1.4rem;
        border-radius: 60px;
    }

    .start-createpage {
        font-size: 1.4rem;
        border-radius: 60px;
    }

    .input-createpage {
        font-size: 1.3rem;
    }

    .container-create {
        border-radius: 35px;
    }

    .error-createpage {
        font-size: 1.3rem;
    }
}

@media only screen and (min-width: 1680px) and (max-width:2350px) {

    .login-createpage {
        font-size: 1.5rem;
        border-radius: 70px;
    }

    .create-createpage {
        font-size: 1.5rem;
        border-radius: 70px;

    }

    .start-createpage {
        font-size: 1.5rem;
        border-radius: 70px;
    }

    .input-createpage {
        font-size: 1.4rem;
        border-radius: 70px;
    }

    .container-create {
        border-radius: 60px;
    }

    .error-createpage {
        font-size: 1.4rem;
    }
}

@media only screen and (min-width: 2350px) and (max-width:2550px) {
    .login-createpage {
        font-size: 1.8rem;
        border-radius: 70px;
    }

    .create-createpage {
        font-size: 1.8rem;
        border-radius: 70px;

    }

    .start-createpage {
        font-size: 1.8rem;
        border-radius: 70px;
    }

    .input-createpage {
        font-size: 1.7rem;
        border-radius: 70px;
    }

    .container-create {
        border-radius: 60px;
    }

    .error-createpage {
        font-size: 1.7rem;
    }
}

@media only screen and (min-width: 2550px) {
    .login-createpage {
        font-size: 3rem;
        border-radius: 100px;
    }

    .create-createpage {
        font-size: 3rem;
        border-radius: 100px;
    }

    .start-createpage {
        font-size: 3rem;
        border-radius: 100px;
    }

    .input-createpage {
        font-size: 2.9rem;
    }

    .container-createpage {
        border-radius: 40px;
    }

    .error-createpage {
        font-size: 2.8rem;
    }
}
</style>
